import { render, staticRenderFns } from "./EntertainmentList.vue?vue&type=template&id=1ed999ae"
import script from "./EntertainmentList.vue?vue&type=script&lang=js"
export * from "./EntertainmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports